import { useEffect, useState } from 'react';

export const useUrlParams = <T>():T => {
  const [params, setParams] = useState<T>({} as T);
  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const arr = Array.from(urlParams.entries());
    const res = arr.reduce<Record<string, string>>((acc, item) => {
      // eslint-disable-next-line prefer-destructuring
      acc[item[0]] = item[1];
      return acc;
    }, {});
    setParams((res as unknown) as T);
  }, []);
  return params;
};
